import { apiPost } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure, showSuccess } from './notificationActions';

export const CANCEL_SIGNATURE_REQUEST = 'LANDLORD_SIGNATURE_REQUESTS::CANCEL_SIGNATURE_REQUEST';

export function cancelSignatureRequest(application_id) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/signable_doc/signature_requests/${application_id}/cancel`;
    return dispatch({
      type: CANCEL_SIGNATURE_REQUEST,
      payload: apiPost(url)
        .then(response => {
          dispatch(showSuccess('cancelSignatureRequestSuccess'));
          return response;
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}
